import { addDays, CalendarResponse, todayIn, type User } from '@squats/shared';
import { useCachedApi } from '../cache.ts';
import { calendarPath } from '../log/sync.ts';

/** Everyone in the group (from the saved week calendar, so it works offline): you first. */
export function usePeople(user: User): { id: string; displayName: string; units: User['units'] }[] {
  const today = todayIn(user.timezone);
  const { data } = useCachedApi(user.id, calendarPath(today, addDays(today, 6)), CalendarResponse);
  return [...(data?.users ?? [])].sort((a, b) => (a.id === user.id ? -1 : b.id === user.id ? 1 : 0));
}

/** "You / Remy" toggle for pages that can show anyone's training. Hidden when you're the only one. */
export function PersonPicker({
  user,
  people,
  value,
  onChange,
  label,
}: {
  user: User;
  people: { id: string; displayName: string }[];
  value: string;
  onChange: (id: string) => void;
  label: string;
}) {
  if (people.length < 2) return null;
  return (
    <span className="chips" role="group" aria-label={label}>
      {people.map((p) => (
        <button key={p.id} type="button" className={`chip toggle${value === p.id ? ' on' : ''}`} aria-pressed={value === p.id} onClick={() => onChange(p.id)}>
          {p.id === user.id ? 'You' : p.displayName}
        </button>
      ))}
    </span>
  );
}
